<!-- 询价历史 -->
<template>
    <div v-loading="loading">
        <div class="search-ctn">
            <div class="search-ctn-left">
                <div class="search-name">供应商</div>
                    <el-select
                        size="small"
                        class="search-item"
                        v-model="searchData.EntpCusId"
                        filterable
                        clearable
                        placeholder="选择客户"
                        remote
                        reserve-keyword
                        :remote-method="searchCustomer"
                        @visible-change="customerVisibleChange($event)"
                    >
                        <el-option
                            v-for="optionItem in customerList"
                            :key="optionItem.EntpCusId"
                            :data-msg="optionItem"
                            :label="optionItem.EntpCusName"
                            :value="optionItem.EntpCusId"
                        ></el-option>
                    </el-select>
                <div class="search-name">品牌</div>
                <div class="search-item goods-categories">
                    <el-select
                        size="small"
                        style="width: 100%"
                        :loading="selLoading"
                        v-model="searchData.BrandName"
                        filterable
                        clearable
                        @visible-change="brandVisibleChange($event)"
                    >
                        <el-option label="全部" value></el-option>
                        <el-option
                        :key="item.Text"
                        v-for="item in brandList"
                        :label="item.Text"
                        :value="item.Text"
                        ></el-option>
                    </el-select>
                </div>
                <div class="search-name">汽配分类</div>
                <div class="search-item goods-categories">
                    <el-select
                        size="small"
                        style="width: 100%"
                        :loading="selLoading"
                        v-model="searchData.Cate"
                        filterable
                        clearable
                        @visible-change="cateVisibleChange($event)"
                    >
                        <el-option label="全部" value></el-option>
                        <el-option
                        v-for="optionItem in typeList"
                        :key="optionItem.Value"
                        :label="optionItem.Text"
                        :value="optionItem.Value"
                        >
                        <div class="option-content">
                            <div>{{ optionItem.Text }}</div>
                        </div>
                        </el-option>
                    </el-select>
                </div>
                <div class="search-name">业务员</div>
                <div class="search-item goods-categories">
                    <el-select
                        v-model="searchData.SId"
                        filterable
                        clearable
                        remote
                        size="small"
                        placeholder="选择业务员"
                        @visible-change="siVisibleChange($event)"
                        style="width: 120px"
                    >
                        <el-option v-for="item in SIdList" :key="item.EmployeeId" :label="item.EmployeeName" :value="item.EmployeeId"></el-option>
                    </el-select>
                </div>
                <el-button
                    size="small"
                    icon="el-icon-search"
                    class="search-btn btn-primary"
                    @click="handleSearch"
                    style="height: 32px"
                >查询</el-button
                >
                <el-button
                    size="small"
                    icon="el-icon-refresh"
                    class="search-btn btn-primary"
                    @click="resetSearch"
                    style="height: 32px"
                >重置</el-button
                >
            </div>
        </div>
        <div class="table-ctn apig-table-ctn">
            <el-table :header-cell-style="{ background: '#F2F6FC' }" :data="tableData" border style="width: 100%">
                <el-table-column width="160px" prop="OrderCode" label="询价单号" show-overflow-tooltip></el-table-column>
                <el-table-column
                    prop="EntpCusName"
                    label="供应商"
                    show-overflow-tooltip
                ></el-table-column>
                <el-table-column width="160px" prop="APCode" label="汽配编码" show-overflow-tooltip></el-table-column>
                <el-table-column prop="EntpTempGoodsName" label="配件名称" show-overflow-tooltip></el-table-column>
                <el-table-column
                    prop="AutoSerise"
                    label="适用车型"
                    show-overflow-tooltip
                ></el-table-column>
                <el-table-column show-overflow-tooltip width="80px" prop="Count" label="数量"></el-table-column>
                <el-table-column
                    show-overflow-tooltip
                    width="80px"
                    prop="Unit"
                    label="单位"
                ></el-table-column>
                <el-table-column show-overflow-tooltip width="100px" prop="Price" label="报价价格"></el-table-column>
                <el-table-column show-overflow-tooltip width="160px" prop="CreateTime" label="采购时间"></el-table-column>
                <el-table-column show-overflow-tooltip width="100px" prop="SName" label="业务员"></el-table-column>
                <el-table-column show-overflow-tooltip width="300px" prop="Remark" label="备注"></el-table-column>
            </el-table>
        </div>
        <div class="dialog-pagination-ctn">
            <el-pagination
                @size-change="handleSizeChange"
                @current-change="handleCurrentChange"
                :current-page="searchData.page"
                :page-sizes="[10, 20, 30, 40, 50]"
                :page-size="searchData.limit"
                layout="total, sizes, prev, pager, next, jumper"
                :total="tableDataLength"
            ></el-pagination>
        </div>
    </div>
</template>
<script>
export default {
    name: '',
    props: {
        EntpTempGoodsId: {
            type: String
        },
        EntpCusId:{
            type: String
        },
        EntpCusName:{
            type: String
        }
    },
    data() {
        return {
            loading: false,
            selLoading: false,
            typeList: [],
            brandList: [],
            customerList: [],
            SIdList:[],
            entpCusName:this.EntpCusName,
            searchData: {
                GoodsId: this.EntpTempGoodsId,
                EntpCusId: this.EntpCusId,
                BrandId: '',
                Cate: '',
                SId:'',
                page: 1,
                limit: 10,
            },
            tableData: [],
            tableDataLength: 0,
            permission: {},
        };
    },
    mounted() {
        this.searchCustomer(this.entpCusName);
        this.getTableData();
    },
    methods: {
        customerVisibleChange(event) {
            let that = this;
            if (event) {
                if (that.EntpCusId && !that.searchData.EntpCusId) {
                    if (that.customerList.length == 1) that.searchCustomer();
                } else {
                    if (that.customerList.length == 0) that.searchCustomer();
                }
            }
        },
        brandVisibleChange(event) {
            let that = this;
            if (event) {
                if (that.brandList.length == 0) that.searchGoodsBrand();
            }
        },
        cateVisibleChange(event) {
            let that = this;
            if (event) {
                if (that.typeList.length == 0) that.searchGoodsType();
            }
        },
        // 搜索顾客
        searchCustomer(key) {
            this.selLoading = true;
            this.$util
                .searchCustomerAndSupplier(key)
                .then(data => {
                    this.customerList = data;
                    this.selLoading = false;
                })
                .catch(() => {
                    this.selLoading = false;
                });
        },
        searchGoodsBrand() {
            this.selLoading = true;
            this.$util
                .searchGoodsBrand()
                .then(data => {
                    this.brandList = data;
                    this.selLoading = false;
                })
                .catch(() => {
                    this.selLoading = false;
                });
        },
        searchGoodsType() {
            this.selLoading = true;
            this.$util
                .searchGoodsType()
                .then(data => {
                    this.typeList = data;
                    this.selLoading = false;
                })
                .catch(() => {
                    this.selLoading = false;
                });
        },
        resetSearch() {
            this.searchData = {
                GoodsId: this.EntpTempGoodsId,
                EntpCusId: this.EntpCusId,
                BrandId: '',
                Cate: '',
                SId:'',
                page: 1,
                limit: 10,
            };
        },
        getTableData() {
            if(this.loading)
                return;
            this.loading = true;
            this.$util
                .axiosGet({
                    url: '/api/EntpInquiryOrder/GetSupplierGoodsHistoriesList',
                    data: this.searchData,
                    hideLoading: true
                })
                .then(res => {
                    this.loading = false;
                    let data = res.data;
                    if (!data) data = [];
                    this.tableData = data;
                    this.tableDataLength = res.count;
                })
                .catch(() => {
                    this.loading = false;
                });
        },
        handleSearch() {
            this.searchData.page = 1;
            this.getTableData();
        },
        handleSizeChange(val) {
            this.searchData.page = 1;
            this.searchData.limit = val;
            this.getTableData();
        },
        handleCurrentChange(val) {
            this.searchData.page = val;
            this.getTableData();
        },
        updateTableData(id) {
            this.resetSearch();
            this.searchData.GoodsId = id;
            this.getTableData();
        },
        getSIdList() {
            this.$util.getCommonSIdList().then(data => {
                this.SIdList = data;
            });
        },
        //当业务员下拉框出现时触发
        siVisibleChange(event) {
            let that = this;
            if (event) {
                that.getSIdList();
            }
        },
    }
};
</script>
<style lang="less" scoped>
.search-name{
    margin:0 10px 0;
}
.search-ctn {
    margin-top: 5px;
}
.data-count {
    padding: 5px;
    display: flex;
    flex-direction: row-reverse;
}
.data-item {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;

    width: 12.5%;
    border-left: 1px solid @border4Color;
    border-right: 1px solid @border4Color;
    > p:nth-child(1) {
        margin-bottom: 5px;
    }
}
</style>
<style lang="less">
.apig-table-ctn {
    .el-table {
        margin-bottom: 5px;
    }
}
</style>
